import { OrganizationStaffTable } from './OrganizationStaffTable';
export default OrganizationStaffTable;
